import React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';
import { useDetectIsAdmin } from '../../helpers/getUser';
import Page404 from '../../pages/courtesy-pages/page404';

export default function AdminRoute({ component, location, ...rest }: { component: React.ComponentType<RouteComponentProps>; location?: string }) {
  const isAdmin = useDetectIsAdmin();
  const Component = component;
  if (!isAdmin) {
    return <Page404 />;
  }
  return <Route {...rest} render={(props) => <Component {...props} />} />;
}
